import React from "react";

interface ModalProps {
  message: string;
  onClose: () => void;
}

const ModalConfirmationResa: React.FC<ModalProps> = ({ message, onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>🎉 Réservation confirmée !</h2>
        </div>
        <div className="modal-body">
          <p>{message}</p>
        </div>
        <div className="modal-footer">
          <button onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirmationResa;
